module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subscriptionplans/subscriptionplans-delete/subscriptionplans-delete.component.css
// module id = ./src/app/subscriptionplans/subscriptionplans-delete/subscriptionplans-delete.component.css
// module chunks = main